module.exports = {
  home: {
    highlights: '热点关注',
    strategicVision: '战略愿景',
    publication: '资源共享',
    lancangMenong: '澜湄通报',
    wantedPerson:"在逃人员通报",
    missingPerson:"失踪人员通报",
    links:"友情链接",
    lmleccNews:"中心动态",
    regoionalEvents:"流域动态",
    memberStatesCooperation:"澜湄国家合作",
    memberStatesInternalAffairs:"澜湄执法动态",
    intelliegenceCenter:"情报融合中心",//情报融合中心
    jointOperationCenter:"联合行动中心",//联合行动中心
    LawEnforcementCapacityBuildingCenter:"执法能力建设中心",//执法能力建设中心
    EmergencyResponseCenter:"应急响应中心",//应急响应中心
    time:"发布时间",
    from:"来源",
    author:"作者",
    share:"分享到",
    home:"首页",
    aboutUs:"关于中心",
    aboutus:"关于中心",
    wantWeDo:"中心活动",
    partners:"合作伙伴",
    resource:"资源分享",
    eLearning:"在线培训",
    contact:"联系我们",
    activities:"中心活动",
    downResource:"资源分享",
    pageView:"访问量",
    registration:"备案号",
    Organizer:"承办",
    Copyright:"版权所有",
    mail:"邮箱",
    RFax:"传真",
    tel:"联系电话",
    summary:"总述",
    leadership:"秘书长简介",
    nameAndLogo:"名字和标志",
    organizationalStructure:"中心秘书处",
    myName:"我们的名字",
    myLogo:"我们的标志",
    RelevantInformation:"相关信息",
    search:"查找",
    name:'姓名',
    age:"年龄",
    ageRange:"年龄范围",
    sex:"性别",
    nationality:'国籍',
    birthAddress:'出生地',
    birthDay:'出生日期',
    description:'描述',
    trait:'人物特征',
    back:'返回',
    detailPage:'详情页面',
    address:"云南省昆明市西山区广福路1097号",
    lmccName:"澜沧江-湄公河综合执法安全合作中心",
    SecretaryGeneral:"代理秘书长",
    DeputySecretaryGeneral:"副秘书长",
    CAMBODIA:"柬埔寨王国",
    MYANMAR:"缅甸联邦共和国",
    LAOS:"老挝人民民主共和国",
    VIETNAM:"越南社会主义共和国",
    CHINA:"中华人民共和国",
    placeholder:"输入关键词或标题...",
    recommondedSearch:"推荐查询",
    content1:"中国与老挝",
    content2:"联合巡逻 2024",
    content3:"老挝禁毒",
    caseNumber:"编号",
    governments:"政府机构",
    internationalOrganization:"国际组织",
    academicInstitution:"学术机构",
    leaveMessage:"我要留言",
    startDate:"开始时间",
    endDate:"结束时间",
    leaveMessageTip:"尊敬的访客，请对我们的工作提出宝贵意见，您的关注和支持是我们前进的动力。",
    contactUs:"联系我们",
    submit:"提交",
    email:"电子邮件",
    theme:"主题",
    text:"正文",
    Secretariat:"中心秘书处简介",
    organizational:"中心组织架构",
    leader:"中心领导介绍",
    noData:"暂无数据",
    centerActivity:"中心活动",
    regionalNews:"区域动态",
    enforcementNews:"执法动态",
    missingPersons:"澜湄通报",
    resources:"资源共享",
    videoCenter:"视频中心",
    thinkTankDynamics:"智库动态",
    crimeMap:"澜湄区域执法动态信息地图",
  },
}



// WEBPACK FOOTER //
// ./src/lang/zh.js